import React from "react";
import Parser from "html-react-parser";
import PropTypes from "prop-types";
import IconoDownload from "./../../assets/img/download/Download Icon.png";

import "./CardTypeFolder.css";

const CardTypeFolder = ({
  titleStyle = { width: "fit-content" },
  title,
  description = "",
  files = [],
  compactDescription = false,
  borderTopColor,
  ...props
}) => {
  return (
    <>
      <div className="card-folder">
        <div className="card-folder-title" style={titleStyle}>
          <h2 className="card-text-title">{title}</h2>
        </div>
        <div
          className="card-folder-body"
          style={{ borderTop: `3px solid ${borderTopColor}` }}
        >
          {description && (
            <span
              className={compactDescription ? "compact-p" : "card-text-body"}
            >
              {Parser(description)}
            </span>
          )}
          {files && (
            <div className="card-files-body">
              {files.map((file, index) => (
                <div key={index} className="file-group">
                  <div>
                    <img
                      src={IconoDownload}
                      width={40}
                      height={40}
                      alt="Descargar"
                    />
                  </div>
                  <div className="file-anchor">
                    <a href={file.fileURL} target="_blank" rel="noreferrer">
                      {file.fileName}
                    </a>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

CardTypeFolder.propTypes = {
  titleStyle: PropTypes.object,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  files: PropTypes.array,
  borderTopColor: PropTypes.string,
};

export default CardTypeFolder;
